export enum RolesEnum {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  DRIVER = 'DRIVER',
  IT_ADMIN_ONLY = 'IT_ADMIN_ONLY',
}
